import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from '@emotion/styled';
import { StyledItem, StyledListItem } from '../Menu/ListItem.styled';
import { fromThemeColors } from '../Theme';
export { StyledList } from '../Menu/List.styled';
export { horizontalPadding, StyledItemText } from '../Menu/ListItem.styled';
export var StyledSelectItem = styled(StyledItem)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n"])), function (props) {
  return props.selected ? fromThemeColors('listItemSelectedBackground') : fromThemeColors('flyoverBackground');
});
export var StyledSelectListItem = styled(StyledListItem)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t:focus > :first-of-type {\n\t\toutline: ", ";\n\t\tbox-shadow: ", ";\n\t}\n"])), function (props) {
  return props.disabled ? '0' : '1';
}, function (props) {
  return props.disabled ? 'none' : 'auto';
});